import React, { Component } from 'react';
import { Row, Col, Form, Modal } from 'react-bootstrap';
import { ContentDiv, BodyHeaderDiv, BodyHeaderText } from '../../theme/MorsTheme';
import Period from '../../components/forms/Period';
import { getTaxReports, getDBA } from '../../Utilities/WSUtil';
import './css/TaxReports.css';

class SearchTaxReport extends Component {

    constructor(props) {
        super(props);
        this.onToggleMode = this.onToggleMode.bind(this);
        this.onCheckAll = this.onCheckAll.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.blurChange = this.blurChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);


        this.state = {
            checkedAllReport: false,
            mid: '',
            mode: 'M',
            monthlySelected: true,
            periodFrom: null,
            periodTo: null,
            formValid: false,
            hasError: false,
            isDefaultError: true,
            errorMessage: '',
            loading: false,
            names: {
                legalName: '',
                corpName: ''
            }
        }
    }

    handleChange(event) {
        this.setState({ mid: event.target.value });
    }

    blurChange(event) {

        var val = event.target.value;

        if (val !== '') {
            getDBA(this.state.mid).then(response =>
                ({
                    legalName: `${response.dbaName}`,
                    corpName: `${response.corpName}`
                })
            ).then(names => this.setState({ names, hasError: false, formValid: true }))
                .catch(error => {
                    var isDefault = true;
                    var message = '';

                    if (error && error.message) {
                        isDefault = false;
                        message = error.message;
                    }
                    this.setState({
                        hasError: true, isDefaultError: isDefault, errorMessage: message, formValid: false, names: { legalName: '', corpName: '' }
                    })

                })
        } else {
            this.setState({
                formValid: false, names: { legalName: '', corpName: '' }
            })
        }


    }

    updateFromAllDays() {

    }

    handleSubmit(event) {
        event.preventDefault();
        var periodSchedFrom = document.getElementById('periodSchedFrom').value;
        var periodYearFrom = document.getElementById('periodYearFrom').value;
        const periodFrom = periodYearFrom + '-' + periodSchedFrom;


        var periodSchedTo = document.getElementById('periodSchedTo').value;
        var periodYearTo = document.getElementById('periodYearTo').value;
        const periodTo = periodYearTo + '-' + periodSchedTo;

        const param = {
            taxSched: this.state.mode,
            periodFrom: periodFrom,
            periodTo: periodTo,
            merchantId: this.state.mid,
            allMid: this.state.checkedAllReport
        }

        this.props.getCwtListParam(param);
        this.props.history.push("/taxReportList");

    }

    onToggleMode(event, mode) {
        if (event.target.checked) {
            const monthlySelected = mode == 'M' ? true : false;
            this.setState({ mode, monthlySelected });
        }

    }


    onCheckAll(event) {
        const checkedAllReport = event.target.checked;
        const validMid = checkedAllReport || (this.state.mid != '' && !this.state.hasError);

        var names = this.state.names;
        var mid = this.state.mid;

        if (checkedAllReport) {
            names = { legalName: '', corpName: '' };
            mid = '';
            document.getElementById('searchSingleId').value = '';
        }

        this.setState({ checkedAllReport: checkedAllReport, formValid: validMid, names, mid });
    }

    renderErrorMessage(hasError, isDefaultError) {
        if (hasError) {
            if (isDefaultError) {
                return (
                    <>
                        <Row>
                            <Col>
                                <span style={{ fontSize: '11px', color: 'red', lineHeight: '5px' }}>
                                    Sorry, the Merchant lD you're searching for does not exist in our system. <br />
                                    Please check the details you selected and try again.
                                    </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}></Col>
                        </Row>
                    </>

                )
            }
            return (
                <>
                    <Row>
                        <Col>
                            <span style={{ fontSize: '11px', color: 'red', lineHeight: '5px' }}>
                                {this.state.errorMessage}
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}></Col>
                    </Row>
                </>
            );

        }
        return null
    }

    render() {
        const { legalName, corpName } = this.state.names;
        return (
            <div>
                <BodyHeaderDiv>
                    <BodyHeaderText>CWT/BIR 2307</BodyHeaderText>
                </BodyHeaderDiv>
                <ContentDiv>

                    {this.renderErrorMessage(this.state.hasError, this.state.isDefaultError)}
                    <Form onSubmit={this.handleSubmit}>
                        <div >
                            <div className="rd-btn-group">
                                <span>
                                    <input type="radio" id="sched-m" name="sched" checked={this.state.monthlySelected} onChange={(event) => this.onToggleMode(event, 'M')} />
                                    <label>Monthly</label>
                                </span>
                                <span>
                                    <input type="radio" id="ched-q" name="sched" onChange={(event) => this.onToggleMode(event, 'Q')} />
                                    <label>Quarterly</label>
                                </span>
                            </div>
                        </div>
                        <Form.Row>
                            <Col sm={2} md={2}>
                                <Form.Label size='sm' style={{ fontWeight: 'bold' }}>MID</Form.Label>

                            </Col>
                            <Col>
                                <Form.Group as={Col} sm={12} controlId="searchSingleId" onChange={this.handleChange} onBlur={this.blurChange}>
                                    <Form.Control maxLength={10} size='sm' type="text" disabled={this.state.checkedAllReport}></Form.Control>
                                </Form.Group>
                            </Col>

                        </Form.Row>

                        <Period mode={this.state.mode} />


                        <Form.Row>
                            <Col sm={2} md={2}>
                                <Form.Label size='sm' style={{ fontWeight: 'bold' }}>Legal Name</Form.Label>

                            </Col>
                            <Col>
                                <Form.Group as={Col} sm={12} controlId="legalName" >
                                    <Form.Control maxLength={10} size='sm' type="text" disabled='true' value={legalName}></Form.Control>
                                </Form.Group>
                            </Col>

                        </Form.Row>
                        <Form.Row>
                            <Col sm={2} md={2}>
                                <Form.Label size='sm' style={{ fontWeight: 'bold' }}>DBA Name</Form.Label>
                            </Col>
                            <Col>
                                <Form.Group as={Col} sm={12} controlId="legalName" >
                                    <Form.Control maxLength={10} size='sm' type="text" disabled='true' value={corpName}></Form.Control>
                                </Form.Group>
                            </Col>

                        </Form.Row>
                        <Row>
                            <Form.Group as={Col} controlId="checkedAllReport" onChange={(event) => this.onCheckAll(event)}>
                                <Form.Check size='lg' label='View All CWT/BIR 2307' style={{ fontWeight: 'bold' }} />
                            </Form.Group>
                            {/* <Form.Group as={Col} controlId="quarterly" onChange={(event) => this.onToggleMode(event)}>
                                <Form.Check size='lg' label='Quarterly' style={{ fontWeight: 'bold' }} />
                            </Form.Group> */}

                        </Row>

                        <div align="center">
                            <input type="submit" className="submit-btn" disabled={!this.state.formValid} value="View" />
                            {/* <input type="submit" className="submit-btn" onClick={(event) => this.handleSubmit(event)} disabled={!this.state.formValid} value ="View" /> */}
                        </div>
                    </Form>
                </ContentDiv>

            </div >
        );

    }


}

export default SearchTaxReport;